import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { Avatar, Box, Button, Card, Divider, Flex, FlexItem, Image, Loader, Text, Segment, Video } from "@fluentui/react-northstar";
import { initializeIcons, Icon } from '@fluentui/react';
import { AcceptIcon, ArrowDownIcon, BanIcon, CloseIcon, LinkIcon, StarIcon, FilesPdfIcon, WordIcon, ExcelIcon, FilesPictureColoredIcon } from '@fluentui/react-icons-northstar';
import { getMeetingData, getQueueById, getCurrentUserPhoto, getQueueRecordingFile, getQueueAttachments } from '../../../api/teamsapp-api';
import { getAppSettings } from '../../../api/settings-api';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import StatusQueueConstants from "../../../constants/status-queue";
import Features from "../../../constants/features";
import './post-meeting-panel.scss';
const moment = require('moment');


interface IPostMeetingPanel extends WithTranslation  {
    queueId: string;
    meetingQueueData: any;
    atendentePhoto: string;
}

interface IPostMeetingState {
    history: any;
    meetingQueueData: any | null;
    atendentePhoto: string | null;
    loading: boolean | null;
    authEnabled: boolean | null;
    govBrEnabled: boolean | null;
    recordingEnabled: boolean | null;
    videos: any[];
    selectedVideo: string;
    videoPart: number;
    features: string[];
    userQueueAttachmentsSettingsEnabled: boolean;
    userQueueAttachmentsUnitSettingsEnabled: boolean;
    loadingSettings: boolean;
    loadingUnitSettings: boolean;
    hasAttachments: boolean;
    attachments: any[];
}

class PostMeetingPanel extends React.Component<IPostMeetingPanel, IPostMeetingState> {
    private localize: TFunction;
    private params: any;

    constructor(props: IPostMeetingPanel) {
        super(props);
        this.localize = this.props.t;
        initializeIcons();

        this.state = {
            history: [],
            meetingQueueData: null,
            atendentePhoto: null,
            loading: true,
            authEnabled: false,
            govBrEnabled: false,
            recordingEnabled: false,
            videos: [],
            selectedVideo: "",
            videoPart: 0,
            features: [],
            userQueueAttachmentsSettingsEnabled: false,
            userQueueAttachmentsUnitSettingsEnabled: false,
            loadingSettings: true,
            loadingUnitSettings: true,
            hasAttachments: false,
            attachments: [],
        }
    }

    public async componentDidMount() {
        microsoftTeams.initialize();

        this.params = this.props;
        let params = this.params.match?.params;

        if (params) {
            if ('id' in params) {
                let id = params['id'];
                let ancora = params['ancora'];

                this.getAppSettings();
                this.getMeeting(ancora);
                this.getMeetingQueueData(id);
            }
        } else {
            this.getMeeting(this.props.meetingQueueData?.Ancora);

            this.setState({
                loading: false,
                history: this.props.meetingQueueData?.History,
            })
        }
    }

    /**
     * Get app settings
     * */
    private getAppSettings = async () => {
        let response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                userQueueAttachmentsSettingsEnabled: response.data.userQueueAttachments,
                features: response.data.featuresList,
                loadingSettings: false,
            })
        }
    }

    public getMeeting = async (ancora: string) => {
        let response = await getMeetingData(ancora);
        if (response.status === 200 && response.data) {
            this.setState({
                authEnabled: response.data.authEnabled,
                govBrEnabled: response.data.govBrEnabled,
                recordingEnabled: response.data.recordAllMeetings,
                userQueueAttachmentsUnitSettingsEnabled: response.data.userQueueAttachments
            })
        }
    }

    public getMeetingQueueData = async (queueId: string) => {
        let response = await getQueueById(queueId);

        if (response.status === 200 && response.data) {
            let responsePhoto = await getCurrentUserPhoto(response.data.atendenteId);

            this.setState({
                meetingQueueData: response.data,
                atendentePhoto: responsePhoto.data,
                history: response.data.History,
                loading: response.data.RecordedFiles || response.data.hasAttachments ? true : false,
            }, async () => {
                if (response.data.RecordedFiles) {
                    const files = response.data.RecordedFiles.files.map((file: any) => {
                        return this.getQueueRecordingFile(file.id)
                    });

                    await Promise.all(files).then(this.fetchRecordingFiles);
                }

                if (response.data.hasAttachments) {
                    let attachmentResponse = await getQueueAttachments(response.data.id);

                    if (attachmentResponse.status === 200 && attachmentResponse.data) {
                        this.setState({
                            hasAttachments: true,
                            attachments: attachmentResponse.data,
                            loading: false,
                        })
                    } else {
                        this.setState({
                            hasAttachments: false,
                            loading: false,
                        })
                    }
                }
            })
        }
    }

    public getQueueRecordingFile = async (fileId: string) => {
        return await getQueueRecordingFile(fileId);
    }

    public fetchRecordingFiles = (response: any) => {
        if (response.length) {
            this.setState({
                videos: response,
                selectedVideo: response[0].data,
                loading: false,
            })
        }
    }

    public renderBoxes = (queueData: any) => {
        return (
            <Flex gap="gap.medium" column>
                <Flex className="boxes" gap="gap.large" space="between">
                    <FlexItem size="size.half">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("InformacoesReuniao")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    <Flex gap="gap.large" column>
                                        <Button
                                            content={this.localize("EntrarAtendimento")}
                                            icon={<LinkIcon />}
                                            onClick={() => {
                                                microsoftTeams.executeDeepLink(queueData.meetingUrl)
                                            }}
                                        />
                                    </Flex>

                                </Card.Body>
                            </Flex>
                        </Segment>
                    </FlexItem>

                    <FlexItem size="size.half">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("Avaliacao")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    {queueData?.Rating ?
                                        <Flex gap="gap.medium" column>
                                            {queueData?.Rating?.Rate &&
                                                <React.Fragment>
                                                    <Flex gap="gap.small">
                                                        <Flex className="ratingBox">
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 1} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 2} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 3} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 4} />
                                                            <StarIcon className="rating" outline={queueData.Rating.Rate < 5} />
                                                        </Flex>

                                                        <Text content={
                                                            queueData.Rating.Rate == 1 ? this.localize("Ruim") :
                                                                queueData.Rating.Rate == 2 ? this.localize("Regular") :
                                                                    queueData.Rating.Rate == 3 ? this.localize("Bom") :
                                                                        queueData.Rating.Rate == 4 ? this.localize("Ótimo") : this.localize("Excelente")
                                                        } />
                                                    </Flex>

                                                    <Divider />
                                                </React.Fragment>
                                            }

                                            {queueData?.Rating?.Comments &&
                                                <Flex gap="gap.small" column>
                                                    <Text weight="semibold" size="small" content={this.localize("Comentarios")} />
                                                    <Text weight="light" size="small" content={queueData?.Rating.Comments} />
                                                </Flex>
                                            }
                                        </Flex>
                                        :
                                        <Flex>
                                            <Text content={this.localize("UsuarioNaoAvaliou")} />
                                        </Flex>
                                    }
                                </Card.Body>
                            </Flex>
                        </Segment>
                    </FlexItem>
                </Flex>

                {(this.state.features?.includes(Features.UserQueueAttachments) &&
                    this.state.userQueueAttachmentsSettingsEnabled &&
                    this.state.userQueueAttachmentsUnitSettingsEnabled &&
                    this.state.hasAttachments) &&

                    <Flex className="attachments">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("Anexos")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    <Flex gap="gap.medium" column>
                                        {this.renderAttachments()}
                                    </Flex>
                                </Card.Body>
                            </Flex>
                        </Segment>
                    </Flex>
                }
                
                {this.state.recordingEnabled && 
                    <Flex className="recording">
                        <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <Flex className="card" gap="gap.large" vAlign="center" column>
                                <Card.Header>
                                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                        <Flex gap="gap.small" column>
                                            <Text content={this.localize("Gravacao")} style={{ margin: 0 }} weight="bold" />
                                        </Flex>
                                    </Flex>
                                </Card.Header>
                                <Card.Body fitted>
                                    <Flex gap="gap.medium" column>
                                        {queueData?.RecordedFiles ?
                                            <Flex gap="gap.medium" column>
                                                {this.renderRecordings()}
                                            </Flex>
                                            :
                                            <Flex>
                                                <Text content={this.localize("NaoPossuiGravacao")} />
                                            </Flex>
                                        }
                                    </Flex>
                                </Card.Body>
                            </Flex>
                        </Segment>
                    </Flex>
                }
            </Flex>
        );
    }

    public renderRecordings = () => {
        return (
            <Flex gap="gap.medium" column fill>
                {this.state.videos && 
                    <React.Fragment>
                        <Video
                            src={this.state.selectedVideo + `#t=0.59`}
                            variables={{ width: '100%' }}
                            controls
                            controlsList="nofullscreen"
                        />

                        <Flex gap="gap.medium" wrap>
                            <Button
                                icon={<ArrowDownIcon />}
                                content={this.localize("DownloadGravacao")}
                                onClick={() => window.open(this.state.selectedVideo)}
                            />

                            {this.state.videos.length > 1 &&
                                this.state.videos.map((file: any, index: number) => {
                                    return (
                                        <Button
                                            key={index}
                                            className="video-parts"
                                            content={`${this.localize("Parte")} ${index + 1}`}
                                            primary={this.state.videoPart == index}
                                            onClick={
                                                () => {
                                                    this.setState({
                                                        selectedVideo: file.data,
                                                        videoPart: index,
                                                    })
                                                }     
                                            }
                                        />
                                    )
                                })
                            }
                        </Flex>
                    </React.Fragment>
                }
            </Flex>
        );
    }

    public renderFiles = (attachment: any) => {
        let fileName = attachment.fileName;
        let icon = null;

        if (fileName?.toLowerCase().includes("pdf"))
            icon = <FilesPdfIcon />
        else if (fileName?.toLowerCase().includes("doc"))
            icon = <WordIcon />
        else if (fileName?.toLowerCase().includes("xls"))
            icon = <ExcelIcon />
        else
            icon = <FilesPictureColoredIcon />

        return (
            <Flex gap="gap.medium">
                {icon}
                <Text
                    as="a"
                    href={attachment.blobUrl}
                    size="small"
                    className="file-link"
                    content={attachment.fileName.split("_")[2]}
                />
            </Flex>
        );
    }

    public renderAttachments = () => {
        return (
            <Flex gap="gap.medium" column fill>
                {this.state.hasAttachments &&
                    <React.Fragment>
                        <Flex gap="gap.medium" vAlign="center" column>
                            {this.state.attachments.map((attachment: any) => {
                                return this.renderFiles(attachment)
                            })}
                        </Flex>
                    </React.Fragment>
                }
            </Flex>
        )
    }
  
    public render(): JSX.Element {
        let statusNaFila = this.state.history?.find((e: any) => e.status == StatusQueueConstants.naFila)?.created ?? null;
        let statusAgendado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)?.created ?? null;
        let statusIniciado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoIniciado)?.created ?? null;
        let statusEmAtendimento = this.state.history?.find((e: any) => e.status == StatusQueueConstants.emAtendimento)?.created ?? null;
        let statusEncerrado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoEncerrado)?.created ?? null;
        let statusInativo = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoInativo)?.created ?? null;
        let statusCancelado = this.state.history?.find((e: any) => e.status == StatusQueueConstants.atendimentoCancelado)?.created ?? null;

        return (
            <div className="main-component-extensibility">
                {this.state.loading ?
                    <Loader />
                    :
                    this.state.meetingQueueData ?
                        <Flex className="post-meeting-panel" column>
                            <Segment className="container-panel">
                                <Flex vAlign="center">
                                    <Flex.Item>
                                        <Flex column padding="padding.medium" vAlign="center" gap="gap.medium">
                                            <Flex vAlign="center" gap="gap.medium">
                                                <Flex column>
                                                    <Text size="large" content={`${this.localize("Atendimento")} #${this.state.meetingQueueData?.id.substr(this.state.meetingQueueData?.id.length - 6)}`} />
                                                    <Text size="small" content={this.state.meetingQueueData?.nome} />
                                                </Flex>
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>

                                    <Flex.Item grow>
                                        <Flex gap="gap.medium" padding="padding.medium" hAlign="end" styles={{ height: "6rem", paddingRight: "2rem" }}>
                                            {(this.state.authEnabled && this.state.govBrEnabled) &&
                                                <React.Fragment>
                                                    <Flex gap="gap.medium">
                                                        <Flex gap="gap.smaller" column>
                                                            {this.state.meetingQueueData?.UserProfile?.userPhoto &&
                                                                <Avatar
                                                                    image={`data:image/jpeg;base64,${this.state.meetingQueueData?.UserProfile?.userPhoto}`}
                                                                    size="large"
                                                                />
                                                            }
                                                        </Flex>

                                                        <Flex gap="gap.smaller" column>
                                                            <Flex gap="gap.small">
                                                                <Text weight="semibold" content={this.localize("Solicitante")} />
                                                                <Image width="45" src="/images/gov-br.svg" />
                                                            </Flex>

                                                            <Text size="small" content={this.state.meetingQueueData?.UserProfile?.userName} />
                                                        </Flex>
                                                    </Flex>
                                                    
                                                    <Divider vertical />
                                                </React.Fragment>
                                            }

                                            <Flex gap="gap.smaller" column>
                                                <Text weight="semibold" content={this.localize("IniciadoEm")} />

                                                {statusIniciado ?
                                                    <Text size="small" content={moment(statusIniciado).format("DD/MM HH:mm")} />
                                                    :
                                                    <Text content="-" />
                                                }
                                            </Flex>

                                            <Divider vertical />

                                            <Flex gap="gap.smaller" column>
                                                <Text weight="semibold" content={this.localize("EncerradoEm")} />
                                                <Text size="small" content={
                                                    statusEncerrado ?
                                                        moment(statusEncerrado).format("DD/MM HH:mm")
                                                        :
                                                    statusInativo ?
                                                        moment(statusInativo).format("DD/MM HH:mm")
                                                        :
                                                    statusCancelado ?
                                                        moment(statusCancelado).format("DD/MM HH:mm")
                                                        :
                                                    ""
                                                }
                                                />
                                            </Flex>

                                            {!statusInativo &&
                                                <React.Fragment>
                                                    <Divider vertical />

                                                    <Flex gap="gap.medium">
                                                        <Flex gap="gap.smaller" column>
                                                            {this.state.atendentePhoto != "" &&
                                                                <Avatar
                                                                    image={`data:image/jpeg;base64,${this.state.atendentePhoto}`}
                                                                    size="large"
                                                                />
                                                            }
                                                            {this.state.atendentePhoto == "" &&
                                                                <Flex gap="gap.smaller">
                                                                    <Avatar size="large" name={this.state.meetingQueueData?.atendenteName} />
                                                                </Flex>
                                                            }
                                                        </Flex>

                                                        <Flex gap="gap.smaller" column>
                                                            <Text weight="semibold" content={this.localize("Atendente")} />
                                                            <Text size="small" content={this.state.meetingQueueData?.atendenteName} />
                                                        </Flex>
                                                    </Flex>
                                                </React.Fragment>
                                            }
                                            

                                        </Flex>
                                    </Flex.Item>
                                </Flex>
                            </Segment>

                            <Flex>
                                {statusNaFila &&
                                    <Flex.Item size="size.quarter">
                                        <Flex
                                            className={this.state.meetingQueueData?.status == StatusQueueConstants.naFila ? "status-selected" : "status"}
                                            vAlign="center"
                                            hAlign="center"
                                            gap="gap.smaller"
                                            column
                                        >
                                            <Text className="status-info" weight="semibold" content={this.localize("NaFila")} />

                                            <Box className="status-icon">
                                                <AcceptIcon size="small" />
                                            </Box>

                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusNaFila).format("HH:mm:ss")} />
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>
                                }

                                {statusAgendado &&
                                    <Flex.Item size="size.quarter">
                                        <Flex
                                            className={this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoAgendado ? "status-selected" : "status"}
                                            vAlign="center"
                                            hAlign="center"
                                            gap="gap.smaller"
                                            column
                                        >
                                            <Text className="status-info" weight="semibold" content={this.localize("Agendado")} />

                                            <Box className="status-icon">
                                                <AcceptIcon size="small" />
                                            </Box>

                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusAgendado).format("HH:mm:ss")} />
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>
                                }

                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={
                                            !statusIniciado ?
                                                "status-error"
                                            : this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoIniciado ?
                                                "status-selected"
                                            :
                                                "status"
                                        }
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className="status-icon">
                                            {!statusIniciado ? <CloseIcon size="small" /> : <AcceptIcon size="small" />}
                                        </Box>

                                        <Text className="status-info" weight="semibold" content={this.localize("AtendimentoIniciado")} />

                                        {statusIniciado ?
                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusIniciado).format("HH:mm:ss")} />
                                            </Flex>
                                            :
                                            <Flex className="status-time" gap="gap.smaller">
                                                <BanIcon />
                                            </Flex>
                                        }
                                        
                                    </Flex>
                                </Flex.Item>
                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={
                                            !statusIniciado ?
                                                "status-error-end"
                                            : !statusEmAtendimento ?
                                                "status-error"
                                            : this.state.meetingQueueData?.status == StatusQueueConstants.emAtendimento ?
                                                "status-selected"
                                            :
                                                "status"
                                        }
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className={statusIniciado ? "status-icon" : ""}>
                                            {!statusIniciado ? <React.Fragment /> : !statusEmAtendimento ? <CloseIcon size="small" /> : <AcceptIcon size="small" />}
                                        </Box>

                                        <Text className="status-info" weight="semibold" content={this.localize("EmAtendimento")} />

                                        {statusEmAtendimento ?
                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusEmAtendimento).format("HH:mm:ss")} />
                                            </Flex>
                                            :
                                            <Flex className="status-time" gap="gap.smaller">
                                                <BanIcon />
                                            </Flex>
                                        }
                                    </Flex>
                                </Flex.Item>
                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={
                                            statusEmAtendimento == null ?
                                                "status-error-end"
                                                :
                                                (this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado ||
                                                 this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoInativo)
                                                    ?
                                                    "status-selected"
                                                    :
                                                    "status"
                                        }
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className={statusEmAtendimento ? "status-icon" : ""}>
                                            {statusEmAtendimento ? <AcceptIcon size="small" /> : <React.Fragment />}
                                        </Box>

                                        <Text
                                            className="status-info"
                                            weight="semibold"
                                            content={this.state.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado ?
                                                this.localize("AtendimentoEncerrado") : this.localize("AtendimentoInativo")}
                                        />

                                        {statusEncerrado ?
                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusEncerrado).format("HH:mm:ss")} />
                                            </Flex>
                                            :
                                            statusInativo ?
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <Icon className="margin-style clock-icon" iconName="Clock" />
                                                    <Text size="small" content={moment(statusInativo).format("HH:mm:ss")} />
                                                </Flex>
                                                :
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <BanIcon />
                                                </Flex>
                                        }
                                    </Flex>
                                </Flex.Item>
                            </Flex>

                            {this.renderBoxes(this.state.meetingQueueData)}
                        </Flex>
                        :
                        <Flex className="post-meeting-panel" column>
                            <Segment className="container-panel">
                                <Flex vAlign="center">
                                    <Flex.Item size="size.half" grow>
                                        <Flex column padding="padding.medium" vAlign="center" gap="gap.medium">
                                            <Flex vAlign="center" gap="gap.medium">
                                                <Image className="logo-img" circular src="/images/logo.png" />

                                                <Flex column>
                                                    <Text size="larger" content={`${this.localize("Atendimento")} #${this.props.meetingQueueData?.id.substr(this.props.meetingQueueData?.id.length - 6)}`} />
                                                    <Text size="medium" content={this.props.meetingQueueData?.nome} />
                                                </Flex>
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>

                                    <Flex.Item size="size.half">
                                        <Flex gap="gap.large" padding="padding.medium" hAlign="end" styles={{ height: "6rem", paddingRight: "2rem" }}>
                                            {(this.state.authEnabled && this.state.govBrEnabled) &&
                                                <React.Fragment>
                                                    <Flex gap="gap.medium">
                                                        <Flex gap="gap.smaller" column>
                                                            {this.props.meetingQueueData?.UserProfile?.userPhoto &&
                                                                <Avatar
                                                                    image={`data:image/jpeg;base64,${this.props.meetingQueueData?.UserProfile?.userPhoto}`}
                                                                    size="large"
                                                                />
                                                            }
                                                        </Flex>

                                                        <Flex gap="gap.smaller" column>
                                                            <Flex gap="gap.small">
                                                                <Text weight="semibold" content={this.localize("Solicitante")} />
                                                                <Image width="45" src="/images/gov-br.svg" />
                                                            </Flex>

                                                            <Text size="small" content={this.props.meetingQueueData?.UserProfile?.userName} />
                                                        </Flex>
                                                    </Flex>

                                                    <Divider vertical />
                                                </React.Fragment>
                                            }

                                            <Flex gap="gap.smaller" column>
                                                <Text weight="semibold" content={this.localize("IniciadoEm")} />
                                                <Text size="small" content={moment(statusIniciado).format("DD/MM HH:mm")} />
                                            </Flex>

                                            <Divider vertical />

                                            <Flex gap="gap.smaller" column>
                                                <Text weight="semibold" content={this.localize("EncerradoEm")} />
                                                <Text size="small" content={
                                                    statusEncerrado ?
                                                        moment(statusEncerrado).format("DD/MM HH:mm")
                                                        :
                                                        statusInativo ?
                                                            moment(statusInativo).format("DD/MM HH:mm")
                                                            :
                                                            ""
                                                }
                                                />
                                            </Flex>

                                            <Divider vertical />

                                            <Flex gap="gap.medium">
                                                <Flex gap="gap.smaller" column>
                                                    {this.props.atendentePhoto != "" &&
                                                        <Avatar
                                                            image={`data:image/jpeg;base64,${this.props.atendentePhoto}`}
                                                            size="large"
                                                        />
                                                    }
                                                    {this.props.atendentePhoto == "" &&
                                                        <Flex gap="gap.smaller">
                                                            <Avatar size="large" name={this.props.meetingQueueData?.atendenteName} />
                                                        </Flex>
                                                    }
                                                </Flex>

                                                <Flex gap="gap.smaller" column>
                                                    <Text weight="semibold" content={this.localize("Atendente")} />
                                                    <Text size="small" content={this.props.meetingQueueData?.atendenteName} />
                                                </Flex>
                                            </Flex>

                                        </Flex>
                                    </Flex.Item>
                                </Flex>
                            </Segment>

                            <Flex>
                                {statusNaFila &&
                                    <Flex.Item size="size.quarter">
                                        <Flex
                                            className={this.props.meetingQueueData?.status == StatusQueueConstants.naFila ? "status-selected" : "status"}
                                            vAlign="center"
                                            hAlign="center"
                                            gap="gap.smaller"
                                            column
                                        >
                                            <Text className="status-info" weight="semibold" content={this.localize("NaFila")} />

                                            <Box className="status-icon">
                                                <AcceptIcon size="small" />
                                            </Box>

                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusNaFila).format("HH:mm:ss")} />
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>
                                }

                                {statusAgendado &&
                                    <Flex.Item size="size.quarter">
                                        <Flex
                                            className={this.props.meetingQueueData?.status == StatusQueueConstants.atendimentoAgendado ? "status-selected" : "status"}
                                            vAlign="center"
                                            hAlign="center"
                                            gap="gap.smaller"
                                            column
                                        >
                                            <Text className="status-info" weight="semibold" content={this.localize("Agendado")} />

                                            <Box className="status-icon">
                                                <AcceptIcon size="small" />
                                            </Box>

                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusAgendado).format("HH:mm:ss")} />
                                            </Flex>
                                        </Flex>
                                    </Flex.Item>
                                }

                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={this.props.meetingQueueData?.status == StatusQueueConstants.atendimentoIniciado ? "status-selected" : "status"}
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className="status-icon">
                                            <AcceptIcon size="small" />
                                        </Box>

                                        <Text className="status-info" weight="semibold" content={this.localize("AtendimentoIniciado")} />

                                        <Flex className="status-time" gap="gap.smaller">
                                            <Icon className="margin-style clock-icon" iconName="Clock" />
                                            <Text size="small" content={moment(statusIniciado).format("HH:mm:ss")} />
                                        </Flex>
                                    </Flex>
                                </Flex.Item>
                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={
                                            statusEmAtendimento == null ?
                                                "status-error"
                                                :
                                                this.props.meetingQueueData?.status == StatusQueueConstants.emAtendimento ?
                                                    "status-selected"
                                                    :
                                                    "status"
                                        }
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className="status-icon">
                                            {statusEmAtendimento ? <AcceptIcon size="small" /> : <CloseIcon size="small" />}

                                        </Box>

                                        <Text className="status-info" weight="semibold" content={this.localize("EmAtendimento")} />

                                        {statusEmAtendimento ?
                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusEmAtendimento).format("HH:mm:ss")} />
                                            </Flex>
                                            :
                                            <Flex className="status-time" gap="gap.smaller">
                                                <BanIcon />
                                            </Flex>
                                        }
                                    </Flex>
                                </Flex.Item>
                                <Flex.Item size="size.quarter">
                                    <Flex
                                        className={
                                            statusEmAtendimento == null ?
                                                "status-error-end"
                                                :
                                                (this.props.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado ||
                                                    this.props.meetingQueueData?.status == StatusQueueConstants.atendimentoInativo)
                                                    ?
                                                    "status-selected"
                                                    :
                                                    "status"
                                        }
                                        vAlign="center"
                                        hAlign="center"
                                        gap="gap.smaller"
                                        column
                                    >
                                        <Box className={statusEmAtendimento ? "status-icon" : ""}>
                                            {statusEmAtendimento ? <AcceptIcon size="small" /> : <React.Fragment />}
                                        </Box>

                                        <Text
                                            className="status-info"
                                            weight="semibold"
                                            content={this.props.meetingQueueData?.status == StatusQueueConstants.atendimentoEncerrado ?
                                                this.localize("AtendimentoEncerrado") : this.localize("AtendimentoInativo")}
                                        />

                                        {statusEncerrado ?
                                            <Flex className="status-time" gap="gap.smaller">
                                                <Icon className="margin-style clock-icon" iconName="Clock" />
                                                <Text size="small" content={moment(statusEncerrado).format("HH:mm:ss")} />
                                            </Flex>
                                            :
                                            statusInativo ?
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <Icon className="margin-style clock-icon" iconName="Clock" />
                                                    <Text size="small" content={moment(statusInativo).format("HH:mm:ss")} />
                                                </Flex>
                                                :
                                                <Flex className="status-time" gap="gap.smaller">
                                                    <BanIcon />
                                                </Flex>
                                        }
                                    </Flex>
                                </Flex.Item>
                            </Flex>

                            {this.renderBoxes(this.props.meetingQueueData)}
                        </Flex>   
                }

            </div>
        );
    }
}

const postMeetingPanelWithTranslation = withTranslation()(PostMeetingPanel);
export default postMeetingPanelWithTranslation;